module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":"Emissionen","scope12Emissions":"Scope 1–2","total":"Absolut","intensity":"Spezifisch","scope":{"s12e":"Scope 1-2","s123e":"Scope 1-3","s1e":"Scope 1","s2e":"Scope 2","s3e":"Scope 3"}}}')
  delete Component.options._Ctor
}
